

























































































import { Component, Prop, Vue } from 'vue-property-decorator';
import QuestionLoading from '@/components/questions/QuestionLoading.vue';
import { PreCollection } from '@/resource/pre-collection/pre-collection.model';
import PreCollectionPreviewOverlay from './PreCollectionPreviewOverlay.vue';
import {
  PaperGeneratedItemsGroup,
  getAlphabet,
} from '@/resource/paper-generated-item/paper-generated-item.model';
import PreCollectionQuestionGenerated from './PreCollectionQuestionGenerated.vue';

@Component({
  components: {
    PreCollectionQuestionGenerated,
    PreCollectionPreviewOverlay,
    QuestionLoading,
  },
})
export default class PreCollectionPaperGeneratedItems extends Vue {
  @Prop({ required: true })
  currentPreCollection!: PreCollection;

  @Prop({ required: true })
  paperGeneratedItemsGroups!: PaperGeneratedItemsGroup[];

  @Prop({ default: false })
  isLastPaperGeneratedItem!: boolean;

  @Prop({ required: true })
  isLoadingAddCollectionItems!: boolean;

  @Prop({ default: true })
  isPreviewOnly!: boolean;

  @Prop({ default: true })
  isLoggedin!: boolean;

  @Prop({ default: false })
  isReachDownloadLimit!: boolean;

  @Prop({ required: true })
  isPremiumStatus!: boolean;

  @Prop({ required: true })
  pdfDownloaded!: number;

  answerHtmls: string[][] = [];

  get overlayDescription() {
    return !this.isLoggedin
      ? 'Daftar Mysoalan Untuk Melanggan'
      : 'Langgan Premium Untuk Melihat Semua';
  }

  get overlayButtonLabel() {
    return !this.isLoggedin ? 'Daftar Sekarang' : 'Langgan Premium';
  }

  addAnswerHtmls(answerHtml: string, order: number) {
    const index = order - 1;

    if (!this.answerHtmls[index]) {
      this.answerHtmls[index] = [];
    }

    this.answerHtmls[index].push(answerHtml);
  }

  getAlphabet(order: number) {
    return getAlphabet(order - 1);
  }
}
